import { Color } from '@kite-js/theme-types';

const grayScale: Color = {
    // Remove this block when do SKYWL-471
    // ------------------------------
    50: '#f9f9fa',
    200: '#dddfe2',
    400: '#90949c',
    500: '#2a2a2e',
    // ------------------------------

    100: '#F4F6F8',
    300: '#C0CAD5',
    // 800: '#364049', uncomment when do SKYWL-471
};

export default grayScale;
